import { Box, Typography } from '@mui/material';
import * as React from 'react';
import { WhiteBgCard } from 'components';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { useSelector } from 'react-redux';
import { selectAuthUser } from 'base/auth/selectors';

const Sponsors = () => {
  const authUser = useSelector(selectAuthUser);
  const { sponsorContent } = authUser.attributes;

  return (
    <WhiteBgCard sx={{ mb: 3 }}>
      <div className="row align-items-center mb-4">
        <div className="col d-none d-md-block">
          <Typography className="lh-1" variant="h6">
            Sponsors
          </Typography>
        </div>
        <div className="col d-block d-md-none">
          <Typography className="lh-1" variant="h5">
            Sponsors
          </Typography>
        </div>
        <div className="col-auto">
          <div className="custom-swiper-pagination sponsors-swiper-pagination d-flex justify-content-center align-items-center text-center" />
        </div>
      </div>

      <Swiper
        modules={[Pagination]}
        spaceBetween={24}
        slidesPerView={3}
        pagination={{
          el: '.sponsors-swiper-pagination',
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className}"></span>`;
          },
        }}
        className=""
        loop={sponsorContent.length > 3}
      >

        {sponsorContent && sponsorContent.length > 0 ? sponsorContent.map((data) => (
          <SwiperSlide key={Math.random()}>
            <Box
              className="w-100 h-auto mw-100 overflow-hidden"
              sx={{ objectFit: 'cover', borderRadius: 1.5 }}
              component="img"
              src={data.url}
            />
          </SwiperSlide>
        )) : (
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            There are no sponsors added
          </Typography>
        )}

      </Swiper>

    </WhiteBgCard>
  );
};

export default Sponsors;
